/* eslint-disable no-redeclare */
import { z } from 'zod';

export const CurrencyString = z
  .string()
  .refine((value) => {
    const cleanString = value.replace(/[^0-9]/g, '');
    const numericValue = parseInt(cleanString, 10);

    return numericValue > 0;
  }, 'Invalid value. Must be greater than $0.')
  .refine((value) => /^((\d{1,3})(,\d{3})*)$/.test(value), {
    message: 'Invalid format. The correct format is dd,ddd.',
  });

export type CurrencyString = z.infer<typeof CurrencyString>;
